import { css } from '@leafygreen-ui/emotion';

export const rootStyles = css`
  width: 100%;
`;
